import SEO from "@/components/SEO";
import Hero from "@/sections/Hero";
import ClientMarquee from "@/sections/ClientMarquee";
import ServicesGrid from "@/sections/ServicesGrid";
import WhyChooseUs from "@/sections/WhyChooseUs";
import IndustriesGrid from "@/sections/IndustriesGrid";
import ProcessTimeline from "@/sections/ProcessTimeline";
import PortfolioGrid from "@/sections/PortfolioGrid";
import CaseStudiesSection from "@/sections/CaseStudiesSection";
import Testimonials from "@/sections/Testimonials";
import PricingCards from "@/sections/PricingCards";
import FAQAccordion from "@/sections/FAQAccordion";
import CTABanner from "@/components/CTABanner";
import ContactSection from "@/sections/ContactSection";
import { FAQS } from "@/data/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "DiziTeQ Innovative Solutions",
  description: "Bengaluru's premium digital marketing agency for websites, Local SEO, Google Business Profile optimization, branding and advertising.",
  url: "https://diziteq.in",
  telephone: "+918123252171",
  email: "hello@diziteq.in",
  address: { "@type": "PostalAddress", addressLocality: "Bengaluru", addressRegion: "Karnataka", addressCountry: "IN" },
  areaServed: "Bengaluru",
  aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "250" },
  mainEntity: {
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question", name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
};

export default function HomePage() {
  return (
    <>
      <SEO
        title="Digital Marketing Agency Bengaluru"
        description="DiziTeQ Innovative Solutions is Bengaluru's premium digital marketing agency. We build websites, dominate Local SEO, optimize Google Business Profiles, and run high-ROI ads that grow local businesses."
        path="/"
        schema={schema}
      />
      <Hero />
      <ClientMarquee />
      <ServicesGrid limit={8} />
      <WhyChooseUs />
      <IndustriesGrid />
      <ProcessTimeline />
      <PortfolioGrid limit={6} />
      <CaseStudiesSection limit={2} />
      <Testimonials />
      <PricingCards />
      <FAQAccordion />
      <div className="py-10"><CTABanner /></div>
      <ContactSection />
    </>
  );
}
